export default "__VITE_ASSET__82a34314__"